import { useState, useEffect } from "react";
import {
  Card,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";

import { getobj, updateObj } from "../../apicall/apicall";
import { headerStyle, searchStyle, boxStyle } from "../../style/style";
import ChangeBillingTypeList from "../ChangeBillingTypeList";
import CloseIcon from "@mui/icons-material/Close";
import ChangeBillingRequestModal from "../Dialogs/ChangeBillingRequestModal";
import { NotificationManager, NotificationContainer } from "react-notifications";
import DeviceHistoryTrail from "../DeviceHistoryTrail";

export default function ChangeBillingType() {
  const [page, setPage] = useState(1);
  const [devices, setDevices] = useState([]);
  const [loader, setLoader] = useState(true);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const getDevices = async () => {
    let url;
    setLoader(true);
    if (search === "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-bill-type-change-requests/?page=" +
        page;
    } else {
      setPage(1);
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-bill-type-change-requests/?page=1&search=" +
        search;
    }

    const res = await getobj(url);
    setDevices(res.results);
    if (res.results.length > 0) {
      if (res.count % 5 > 0) {
        setTotalPage(Math.floor(res.count / 5) + 1);
      } else {
        setTotalPage(Math.floor(res.count / 5));
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    getDevices();
  }, [page]);

  const handleSearch = (e) => {
    e.preventDefault();
    setLoadData(!loadData);
  };

  // Function to handle approval
  const onActionForBillingType = (data) => {
    const url = `${process.env.REACT_APP_ZEWA_URL}device/bill-type-change-action/`;

    // Show loader
    setLoader(true);

    updateObj(url, data)
      .then((response) => {
        console.log("Response:", response);
        if (response.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.success(response.data.Message);

          // Call getDevices to refresh the data
          getDevices();
          setOpenEditModal(false); // Close the modal
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(response.data.Message);
          getDevices();
          setOpenEditModal(false);
        }
      })
      .catch((error) => {
        console.log("Response in catch:", error);
        NotificationManager.remove(NotificationManager.listNotify[0]);
        NotificationManager.error(
          "An error occurred while processing the request."
        );
        setOpenEditModal(false);
      })
      .finally(() => {
        setOpenEditModal(false);
        // Hide loader
        setLoader(false);
      });
  };

  return (
    <div>
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>
          Requests for Billing Type Change
          <form onSubmit={handleSearch} style={searchStyle}>
            <FormControl variant="standard" sx={searchStyle}>
              <InputLabel htmlFor="input-with-icon-adornment">
                Search Device
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchSharpIcon color="primary" />
                  </InputAdornment>
                }
                value={search}
                onInput={(e) => {
                  setSearch(e.target.value);
                  if (e.target.value === "") {
                    handleSearch(e);
                  }
                }}
              />
            </FormControl>
          </form>
        </Card>
      </Card>
      {loader ? (
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>
            <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
          </Card>
        </Box>
      ) : devices.length > 0 ? (
        <Box style={boxStyle}>
          <ChangeBillingTypeList
            devices={devices}
            page={page}
            setPage={setPage}
            totalPage={totalPage}
            openEditModal={openEditModal}
            setOpenEditModal={setOpenEditModal}
            openViewModal={openViewModal}
            setOpenViewModal={setOpenViewModal}
            setSelectedDevice={setSelectedDevice}
          />
        </Box>
      ) : (
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>No request for billing type change found</Card>
        </Box>
      )}
      {openEditModal && (
        <ChangeBillingRequestModal
          open={openEditModal}
          device={selectedDevice}
          onClose={() => setOpenEditModal(false)}
          onAction={onActionForBillingType}
        />
      )}
      {openViewModal && (
        <Dialog
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Device History
            <IconButton
              aria-label="close"
              onClick={() => setOpenViewModal(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DeviceHistoryTrail id={selectedDevice.id} />
          </DialogContent>
        </Dialog>
      )}
      <NotificationContainer />
    </div>
  );
}
